/**
 * @desc 分页
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  defs.appCenter.IPage<defs.appCenter.AppDomainResponseDto>
>;
export function request(
  params: API.appCenter.appDomain.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/appDomain/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
